import React, { Component } from 'react';
import FormButton from '../../style/styledComponents/FormButton';
import CryptoJS from 'crypto-js';

import InputMask from 'react-input-mask';
import cpfCheck from 'cpf-check';
import moment from 'moment';

import { FiAlertCircle } from 'react-icons/fi';
import {
	FaThumbsUp,
	FaRestroom,
	FaIdCard,
	FaPhoneAlt,
	FaCalendarAlt,
	FaUser,
	FaEnvelope,
	FaCheckCircle,
	FaTimesCircle
} from 'react-icons/fa';
import TitleSubscriber from '../../style/styledComponents/TitleSubscriber';
import FormField from '../../style/styledComponents/FormField';
import * as yup from 'yup';
import { Field, Form, Formik, useField } from 'formik';
import Loading from '../../Components/Loading';
import { campaignUtils } from '../../utils';
import { handleValidationCpf } from '../../utils/validationCpf';
import BoxSize from '../../style/styledComponents/BoxSize';
import { number } from 'yup';
//import plus from '../../img/plus.svg';
//import { Link } from 'react-router-dom';
import ErroMsgValidacao from '../ErroMsgValidacao';
class FormBeneficiario extends Component {
	constructor() {
		super();

		this.state = {
			inputData: {
				name: '',
				cpf: '',
				phone: '',
				birthday: '',
				gender: '',
				email: '',
				checkedEmail: true,
				checkedWhatsapp: false
			},

			hasMoreThanOneSub: false,
			subscriberList: 0,
			box: false,
			loading: false,
			dataValidationCpf: {},
			isLoading: false,
		};

		this.initialValues = this.state.inputData;
		this.setField = this.setField.bind(this);
	}

	componentWillMount() {
		const { VivoUser } = this.props;
		const vivoUser = VivoUser.data;

			function decrypt(encrypted, passphrase) {
				const bytes = CryptoJS.AES.decrypt(encrypted, passphrase);
				const decrypted = bytes.toString(CryptoJS.enc.Utf8);
				return decrypted;
			 }
			
			const currentUrl = window.location.href;
			const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
			const payloadValue = urlParams.get('inf');

			const decodebase64Url = window.atob(payloadValue);
	
		const passphrase = process.env.REACT_APP_DECRYPT_KEY;
			const decrypted = decrypt(decodebase64Url, passphrase);
			window.sessionStorage.setItem("data_person", decrypted);
		const _person = decrypted ? JSON.parse(decrypted): '';
	
		if (this.props.initialData) {
			let inputData = { ...this.state.inputData };
			let initialData = this.formatFields(this.props.initialData);
			if (Object.keys(vivoUser).length > 0) {
				let phone =
					vivoUser.phone.substr(0, 2) + ' ' + vivoUser.phone.substr(2);
				inputData.phone = phone;
			} else if (window.location.hostname === 'localhost') {
				inputData.name = _person.name || 'Benedita Antonieta Marinaura';
				inputData.cpf = _person.cpf || '324.675.000-98'; 
				inputData.phone = _person.phone || '48 999251896';
				inputData.birthday = moment(_person.birthday).format('DD/MM/YYYY') || '04/09/1978';
				inputData.gender = _person.gender || 'Female';
				inputData.email = _person.email || 'ze.ruas@yalo.com.br';
				inputData.checkedEmail = initialData.checkedEmail || true;
				inputData.checkedWhatsapp = initialData.checkedWhatsapp || false;  
			} else if (_person) {				
				inputData.name = _person.name || '';
				inputData.cpf = _person.cpf || '';
				inputData.phone = _person.phone || '';
				inputData.birthday = moment(_person.birthday).format('DD/MM/YYYY') || '';
				inputData.gender = _person.gender || '';
				inputData.email = _person.email || '';
				inputData.checkedEmail = initialData.checkedEmail || true;
				inputData.checkedWhatsapp = initialData.checkedWhatsapp || false;
			} else {
				inputData.name = initialData.name || '';
				inputData.cpf = initialData.cpf || '';
				inputData.phone = initialData.phone || '';
				inputData.birthday = initialData.birthday || '';
				inputData.gender = initialData.gender || '';
				inputData.email = initialData.email || '';
				inputData.checkedEmail = initialData.checkedEmail || true;
				inputData.checkedWhatsapp = initialData.checkedWhatsapp || false;
			}

			this.setState({
				inputData
			});
			this.initialValues = inputData;
		}
		this.setState({ subscriberList: this.props.subscriptionList.length });
	}

	componentDidMount() {
		const { VivoUser } = this.props;
		let vivoUser = VivoUser.data;		

		if (window.jQuery) {
			let $ = window.jQuery;

			$('[data-toggle="tooltip"]').tooltip();
		}
		if (Object.keys(vivoUser).length > 0) {
			this.setState({
				isVivo: true
			});
		}

		this.setState({ subscriberList: this.props.subscriptionList.length });		

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.initialData && nextProps.isEdit) {
			this.setState({ inputData: nextProps.initialData });
			this.initialValues = nextProps.initialData;
		}
		
		if (nextProps.subscriptionList) {
			if (this.props.subscriptionList.length > 0) {
				this.setState({ hasMoreThanOneSub: true });				
			}
		}

		if (nextProps.cleanForm) {
			this.setState({
				inputData: {
					name: '',
					cpf: '',
					phone: '',
					birthday: '',
					gender: '',
					email: '',
					checkedEmail: true,
					checkedWhatsapp: false
				}
			});
			this.initialValues = {
				name: '',
				cpf: '',
				phone: '',
				birthday: '',
				gender: '',
				email: '',
				count: this.props.subscriptionList.length,
				checkedEmail: true,
				checkedWhatsapp: false
			};
		}
		this.setState({ subscriberList: this.props.subscriptionList.length });
	}

	componentDidUpdate(prevProps) {
    const decrypted = window.sessionStorage.getItem("data_person");

    this.handleSubscriptionListChange(prevProps);
    this.handleStoreChange(prevProps, decrypted);
	}

	handleSubscriptionListChange(prevProps) {
		if (this.props.subscriptionList !== prevProps.subscriptionList) {
			if (this.props.subscriptionList.length === '0') {
				this.setState({ hasMoreThanOneSub: false });
			}
		}
	}

	handleStoreChange(prevProps, decrypted) {
		const signatureChosen = this.props.SignatureChosen !== prevProps.SignatureChosen;
    const cmDrConsulta = this.props.CmDrConsulta !== prevProps.CmDrConsulta;
    const dataExists = decrypted;

    if ((signatureChosen || cmDrConsulta) && dataExists) {
			this.validateCpf(decrypted);
    }
	}

	validateCpf(decrypted) {
		const _person = JSON.parse(decrypted);
		this.validationCpf(_person.cpf);
	}

	formatFields(data) {
		for (var fieldName in data) {
			switch (fieldName) {
				case 'cpf':
					data[fieldName] = data[fieldName].replace(
						/^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/i,
						'$1.$2.$3-$4'
					);
					break;
				case 'phone':
					data[fieldName] = data[fieldName].replace(
						/^([0-9]{2})([0-9]{4})([0-9]{4,5})$/i,
						'($1) $2-$3'
					);
					break;
				case 'birthday':
					data[fieldName] = data[fieldName].replace(
						/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/i,
						'$3/$2/$1'
					);
					break;
				default:
			}
		}

		return data;
	}

	getErrorMsg(name) {
		let errorMsgs = {
			name: 'Nome inválido',
			cpf: 'CPF inválido',
			phone: 'Telefone inválido',
			birthday: 'Data de nascimento inválida',
			gender: 'Gênero inválido',
			email: 'E-mail inválido'
		};

		return errorMsgs[name];
	}

	checkField(name, value) {
		let isValidField = false;
		let checkField = {
			name: /^([\s]?([a-zà-ú][']?)+\s)+([a-zà-ú][']?)+[\s]?$/i,
			cpf: /^([0-9]{3}\.){2}[0-9]{3}-[0-9]{2}/,
			phone: /^[0-9]{2}\s[0-9]{8,9}|(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
			birthday: /^([0-9]{2}\/){2}[0-9]{4}$/i,
			gender: /^(Male|Female|Other)$/,
			email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		};

		if (name === 'checkedWhatsapp' || name === 'checkedEmail') {
			isValidField = true;
		}
		if (
			name !== 'subscriptionId' &&
			name !== 'lastname' &&
			name !== 'orderId' &&
			name !== 'addressId' &&
			name !== 'subscriptionParentId' &&
			name !== 'checkedWhatsapp' &&
			name !== 'checkedEmail' &&
			name !== 'accepted_email' &&
			name !== 'accepted_sms' &&
			name !== 'accepted_whatsapp' &&
			name !== 'position'
		) {
			if (checkField[name] && checkField[name].test(value)) {
				switch (name) {
					case 'cpf':
						isValidField = cpfCheck.validate(value);
						break;
					case 'birthday':
						let dateValue = moment(value, 'DD/MM/YYYY');
						let currentDate = moment();
						let passLimitDate = moment().subtract(115, 'years');
						isValidField = dateValue.isBetween(passLimitDate, currentDate);
						break;
					case 'phone':
						if (value.length === 12 && value[3] !== '9') {
							isValidField = false;
						} else {
							isValidField = true;
						}
						break;

					default:
						isValidField = true;
						break;
				}
			}
		}

		return isValidField;
	}

	
	async validationCpf(value) {
		this.setState({ loading: true });

		const { CmDrConsulta, SignatureChosen, Levelled } = this.props;
		
		const cmDrConsulta = CmDrConsulta.data;
		const signatureChosen = SignatureChosen.data;
		const levelled = Levelled.data;
		
		const yaloId =
		signatureChosen.yaloId || cmDrConsulta.yaloId || levelled.plan.yaloId;
		const cpf = value.replace(/(\.|-)/g, '');
		
		const response = await handleValidationCpf(cpf, yaloId);
		if (response.status === 200) {
			const res = response.data.response;
			this.setState({ loading: false, dataValidationCpf: res });
			if (res.status === 'true') {
				this.setState({ box: true });
			}
		}
	}

	setField(e, setFieldValue) {
		const { VivoUser, SignatureChosen, Levelled, CmDrConsulta } = this.props;
		const isCmDrConsulta =
			Object.keys(CmDrConsulta.data).length > 0 ? true : false;
		const isSignatureChosen =
			Object.keys(SignatureChosen.data).length > 0 ? true : false;
		const isLevelled = Levelled.data.status === 'success' ? true : false;

		let value = e.target.value;
		let name = e.target.getAttribute('name');

		if (
			name === 'checkedWhatsapp' ||
			name === 'checkedEmail' ||
			name === 'accepted_email' ||
			name === 'accepted_whatsapp'
		) {
			value = e.target.checked;
		}

		if (this.state.isVivo && name === 'phone') {
			let phone =
				VivoUser.data.phone.substr(0, 2) + ' ' + VivoUser.data.phone.substr(2);
			value = phone;
		}
		if (name === 'phone') {
			value = value.replace(/_$/g, '');
		}
		if (name === 'name') {
			value = value.replace(/( )+/g, ' ');
		}

		let inputData = { ...this.state.inputData };
		inputData[name] = value;
		setFieldValue(name, inputData[name]);

		if (this.props.isEdit) {
			this.setState({
				inputData
			});
		} else {
			this.setState({ inputData }, () => {
				this.props.isCompleted();
			});
		}
		 if (isCmDrConsulta || isSignatureChosen || isLevelled) {
			if (name === 'cpf') {
				if (cpfCheck.validate(value)) {
					this.validationCpf(value);
				}
			}
		}
	}

	removeWhiteSpace(e, setFieldValue) {
		if (this.checkField('name', e.target.value)) {
			let value = e.target.value.trim();

			let inputData = { ...this.state.inputData };

			inputData['name'] = value;
			setFieldValue('name', inputData['name']);

			if (this.props.isEdit) {
				this.setState({
					inputData
				});
			} else {
				this.setState(
					{
						inputData
					},
					() => {
						this.props.isCompleted();
					}
				);
			}
		}
	}

	removeAcento(text) {
		text = text.replace(new RegExp('[ÁÀÂÃ]', 'g'), 'A');
		text = text.replace(new RegExp('[ÉÈÊ]', 'g'), 'E');
		text = text.replace(new RegExp('[ÍÌÎ]', 'g'), 'I');
		text = text.replace(new RegExp('[ÓÒÔÕ]', 'g'), 'O');
		text = text.replace(new RegExp('[ÚÙÛ]', 'g'), 'U');
		text = text.replace(new RegExp('[Ç]', 'g'), 'C');
		text = text.replace(new RegExp('[áàâã]', 'g'), 'a');
		text = text.replace(new RegExp('[éèê]', 'g'), 'e');
		text = text.replace(new RegExp('[íìî]', 'g'), 'i');
		text = text.replace(new RegExp('[óòôõ]', 'g'), 'o');
		text = text.replace(new RegExp('[úùû]', 'g'), 'u');
		text = text.replace(new RegExp('[ç]', 'g'), 'c');
		text = text.replace(new RegExp("[']", 'g'), ' ');

		return text;
	}
	getData() {
		let inputData = this.state.inputData;
		let dataSend = {};

		if (!/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(inputData.cpf)) {
			inputData.cpf = inputData.cpf.replace(
				/(\d{3})(\d{3})(\d{3})(\d{2})/,
				'$1.$2.$3-$4'
			);
		}
		
		for (var fieldName in inputData) {
			let value = inputData[fieldName];

			if (this.checkField(fieldName, inputData[fieldName])) {
				if (fieldName === 'name') {
					value = this.removeAcento(value);
				}
				dataSend[fieldName] = {
					error: false,
					value
				};
			} else {
				if (inputData[fieldName] === '') {
					dataSend[fieldName] = {
						error: true,
						msg: 'Campo vazio'
					};
				} else {
					dataSend[fieldName] = {
						error: true,
						msg: this.getErrorMsg(fieldName)
					};
				}
			}
		}

		return dataSend;
	}

	closeBox() {
		const dataValidationCpf = this.state.dataValidationCpf;
		if (dataValidationCpf.cod == 1) {
			this.setState({ box: false });
		} else {
			this.setState({
				inputData: {
					name: '',
					cpf: '',
					phone: '',
					birthday: '',
					gender: '',
					email: ''
				},
				box: false
			});
		}
	}

	clearField() {
		const { Payer, Subscription } = this.props
		
		if(Payer.data.statusCode){
			this.setState({
				inputData: {
				...this.state.inputData,
				email: ''
				}
			});
		}
		if(Subscription.data?.error?.statusCode === 403){
			this.setState({
				inputData: {
				...this.state.inputData,
				cpf: ''
				}
			});
		}
	}
	
	render() {


		const validationSchema = yup.object().shape({
			name: yup
				.string('Insira o nome')
				.required('Insira o nome')
				.test('validName', 'Nome inválido', function(e) {
					let validName = true;
					if (!/^([\s]?([a-zà-ú][']?)+\s)+([a-zà-ú][']?)+[\s]?$/i.test(e)) {
						validName = false;
					}
					return validName;
				}),
			cpf: yup
				.string('Insira o CPF')
				.required('Insira o CPF')
				.min(14, 'CPF inválido')
				.test('validCpf', 'CPF inválido', function(e) {
					let validCpf = true;
					if (/^([0-9]{3}\.){2}[0-9]{3}-[0-9]{2}/.test(e)) {
						validCpf = cpfCheck.validate(e);
					}
					return validCpf;
				}),
			phone: yup
				.string('Insira o telefone')
				.required('Insira o telefone')
				// .min(11, 'Telefone inválido')
				// .max(12, 'Telefone inválido')
				.test('validPhone', 'Telefone inválido', function(e) {
					let validPhone = false;

					if (
						/^[0-9]{2}\s[0-9]{8,9}|(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(
							e
						)
					) {
						if ((e.length === 12 && e[3] !== '9') || e.length <= 10) {
							validPhone = false;
						} else {
							validPhone = true;
						}
					}

					return validPhone;
				}),
			birthday: yup
				.string('Insira a data de nascimento')
				.required('Insira a data de nascimento')
				.test('notEmptyDate', 'Insira a data de nascimento', function(e) {
					let notEmptyDate = true;
					if (e === '__/__/____') {
						notEmptyDate = false;
					}
					return notEmptyDate;
				})
				.test('validDate', 'Data de nascimento inválida', function(e) {
					let validDate = true;
					if (e !== '' && e !== '__/__/____') {
						if (/^([0-9]{2}\/){2}[0-9]{4}$/i.test(e)) {
							let dateValue = moment(e, 'DD/MM/YYYY');
							let currentDate = moment();
							let passLimitDate = moment().subtract(115, 'years');
							validDate = dateValue.isBetween(passLimitDate, currentDate);
						} else {
							validDate = false;
						}
					}
					return validDate;
				}),
			gender: yup.string('Insira o gênero').required('Insira o gênero'),
			email: yup
				.string('Insira o e-mail')
				.required('Insira o e-mail')
				.email('E-mail inválido')
				.test('validEmail', 'E-mail inválido', function(e) {
					let validEmail = true;
					if (
						!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
							e
						)
					) {
						validEmail = false;
					}
					return validEmail;
				})
		});

		const { loja } = this.props.match.params;
		let fieldError = '';
		if (this.props.error) {
			fieldError = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p>{this.props.error}</p>
						</div>
						<FormButton className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-ok'
								onClick={() => {
									this.clearField();
									this.props.errorAccept();
								}}
							>
								<FaThumbsUp size={18} /> Ok
							</button>
						</FormButton>
					</div>
				</div>
			);
		}
		if (this.state.box) {
			fieldError = (
				<ErroMsgValidacao
					close={this.closeBox.bind(this)}
					dataValidationCpf={this.state.dataValidationCpf}
				/>
			);
		}
		this.props.onData(this.getData());

		const SignatureChosen = this.props.SignatureChosen.data;
		const Levelled = this.props.Levelled.data;
		const CmDrConsulta = this.props.CmDrConsulta.data;

		const dependentIsActive = sessionStorage.getItem('dependentIsActive');
		const nameSite =
			CmDrConsulta.name_site || SignatureChosen.name_site || Levelled.name_site;

		return (
			Levelled.length <= 0 && 
			CmDrConsulta.length <= 0 && 
			SignatureChosen.length <= 0 ? (
				<Loading show />
			) : (
			<>	
				<Loading show={this.state.loading} />				
				<BoxSize className='form-step form-step-1'>
					{fieldError}
					<div className='form-wiz'>
						{/* <Timeline ass={'not-empty'} /> */}
						{/* <ul >
							<li>
								<span className='f-bold dot'>1</span>{' '}
								<span className='dot-text'>Assinante</span>
							</li>
						</ul> */}
					</div>

					<TitleSubscriber>
						 {this.props.subscriptionList.length === 0 &&
						  dependentIsActive == true  ? (
							  <h2>
								Quem é o titular do{' '}
								<strong className='f-bold'>{nameSite}</strong>?
							</h2>
						) : this.props.subscriptionList.length > 0 &&
						  dependentIsActive == true ? (
							<h4>
								Para quem mais você quer dar a assinatura{' '}
								<strong className='f-bold'>{nameSite}</strong>?
							</h4>
						) : (!this.state.hasMoreThanOneSub && loja === 'yalo') ||
						  (!this.state.hasMoreThanOneSub && loja === 'qualicorp') ? (
							<h2>
								Para quem é o{' '}
								<strong className='f-bold'>{SignatureChosen.name_site}</strong>?
							</h2>
						) : (this.state.hasMoreThanOneSub && loja === 'yalo') ||
						  (this.state.hasMoreThanOneSub && loja === 'qualicorp') ? (
							<h4>
								Para quem mais você quer dar a assinatura{' '}
								<strong className='f-bold'>{SignatureChosen.name_site}</strong>?
							</h4>
						) : !this.state.hasMoreThanOneSub ||
						  loja === 'epay' ||
						  loja === 'vivoavulso' ||
						  loja === 'levelled' ? (
							<h2>
								Para quem é o <strong className='f-bold'>Yalo</strong>?
							</h2>
						) : (
							<h4>
								Para quem mais você quer dar a assinatura{' '}
								<strong className='f-bold'>Yalo</strong>?
							</h4>
						)}
					</TitleSubscriber>

					{/* Formulário de dados pessoais */}
					<Formik
						initialValues={this.state.inputData}
						validationSchema={validationSchema}
						validateOnChange
						validateOnBlur
						validateOnMount
						enableReinitialize
						onSubmit={() => {}}>
						{({ values, errors, touched, setFieldValue, handleBlur }) => {
							return (
								<Form>
									<FormField className=' inputHeight'>
										<CustomInputMask
											maxLength='80'
											id='nome'
											name='name'
											onChange={e => {
												this.setField(e, setFieldValue);
											}}
											onBlur={
												(e => this.removeWhiteSpace(e, setFieldValue),
												handleBlur)
											}
											value={values.name}
											required
										/>
										<label
											htmlFor='nome'
											className={values.name === '' ? 'subscriber' : ''}>
											<FaUser size={10} className='icon' /> Nome Completo
										</label>
										{(touched.name || this.props.fieldsTouched) && errors.name && (
											<div className='error-msg'>
												<FiAlertCircle size={13} />
												<small className='credit-card-error'>
													{errors.name}
												</small>
											</div>
										)}
									</FormField>

									<div className='form-size'>
										<div className='form-size-1'>
											<FormField className='inputHeight'>
												<CustomInputMask
													id='cpf'
													name='cpf'
													mask='999.999.999-99'
													maskChar=''
													onChange={e => {
														this.setField(e, setFieldValue);
													}}
													onBlur={handleBlur}
													value={values.cpf}
													required
												/>
												<label
													htmlFor='cpf'
													className={values.cpf === '' ? 'subscriber' : ''}>
													<FaIdCard size={10} className='icon' /> CPF
												</label>
												{(touched.cpf || this.props.fieldsTouched) &&
													errors.cpf && (
														<div className='error-msg'>
															<FiAlertCircle size={13} />
															<small className='credit-card-error'>
																{errors.cpf}
															</small>
														</div>
													)}
											</FormField>
										</div>
										<div className='form-size-1 '>
											<FormField className=' inputHeight'>
												<CustomInputMask
													id='telefone'
													name='phone'
													mask={
														loja === 'levelled'
															? '+1 999 999-9999'
															: '99 999999999'
													}
													maskChar=''
													onChange={e => {
														this.setField(e, setFieldValue);
													}}
													onBlur={handleBlur}
													value={values.phone}
													required
												/>

												<label
													htmlFor='telefone'
													className={values.phone === '' ? 'subscriber' : ''}>
													<FaPhoneAlt size={10} className='icon' /> Telefone
												</label>
												{(touched.phone || this.props.fieldsTouched) &&
													errors.phone && (
														<div className='error-msg'>
															<FiAlertCircle size={13} />
															<small className='credit-card-error'>
																{errors.phone}
															</small>
														</div>
													)}
											</FormField>
										</div>
									</div>

									<FormField className='inputHeight'>
										<CustomInputMask
											id='email'
											name='email'
											onChange={e => {
												this.setField(e, setFieldValue);
											}}
											onBlur={handleBlur}
											value={values.email}
											required
										/>
										<label
											htmlFor='email'
											className={values.email === '' ? 'subscriber' : ''}>
											<FaEnvelope size={10} className='icon' /> E-mail
										</label>
										{(touched.email || this.props.fieldsTouched) &&
											errors.email && (
												<div className='error-msg'>
													<FiAlertCircle size={13} />
													<small className='credit-card-error'>
														{errors.email}
													</small>
												</div>
											)}
									</FormField>

									<div className='form-size'>
										<div className='form-size-1'>
											<FormField className='inputHeight'>
												<CustomInputMask
													id='nascimento'
													name='birthday'
													mask='99/99/9999'
													maskChar='_'
													onChange={e => {
														this.setField(e, setFieldValue);
													}}
													onBlur={handleBlur}
													value={values.birthday}
													required
												/>
												<label
													htmlFor='nascimento'
													className={
														values.birthday === '' ? 'subscriber' : ''
													}>
													<FaCalendarAlt size={10} className='icon' /> Data de
													Nascimento
												</label>
												{(touched.birthday || this.props.fieldsTouched) &&
													errors.birthday && (
														<div className='error-msg'>
															<FiAlertCircle size={13} />
															<small className='credit-card-error'>
																{errors.birthday}
															</small>
														</div>
													)}
											</FormField>
										</div>
										<div className='form-size-1'>
											<FormField className='inputHeight '>
												<FormField className='select-new form-select '>
													<Field
														className='form-control'
														id='gender'
														name='gender'
														as='select'
														onChange={e => {
															this.setField(e, setFieldValue);
														}}
														onBlur={handleBlur}
														value={values.gender}
														required>
														<option></option>
														<option value='Male' key='Male'>
															Masculino
														</option>
														<option value='Female' key='Female'>
															Feminino
														</option>
													</Field>
													<label
														htmlFor='gender'
														className={
															values.gender === '' ? 'subscriber' : ''
														}>
														<FaRestroom size={10} className='icon' /> Gênero
													</label>
													{(touched.gender || this.props.fieldsTouched) &&
														errors.gender && (
															<div className='error-msg'>
																<FiAlertCircle size={13} />
																<small className='credit-card-error'>
																	{errors.gender}
																</small>
															</div>
														)}
												</FormField>
											</FormField>
										</div>
									</div>
									{/* prettier-ignore */

									this.state.subscriberList === 0 || this.initialValues?.position == 0 && this.props.isEdit || this.props.position === 0 && this.props.isEdit? (
											<FormField>
												<div className='notification-checkbox'>
													<Field
													type='checkbox'
													name='checkedEmail'
													id='checkedEmail'
														onBlur={handleBlur}
														checked={values.checkedEmail}
														onChange={e => {
															this.setField(e, setFieldValue);
														}}
														value={values.checkedEmail}
													/>
													<h5>
														Eu aceito receber <strong>SMS</strong> e{' '}
														<strong>e-mail</strong> com as promoções e produtos
														da Yalo e parceiros.
													</h5>
												</div>

												<div className='notification-checkbox'>
													<Field
														type='checkbox'
														name='checkedWhatsapp'
														id='checkedWhatsapp'
														checked={values.checkedWhatsapp}
														onChange={e => {
															this.setField(e, setFieldValue);
														}}
														onBlur={handleBlur}
														value={values.checkedWhatsapp}
													/>

													<h5>
														Eu aceito receber <strong>whatsapp</strong> com as
														promoções e produtos da Yalo e parceiros.
													</h5>
												</div>
												{(touched.checkedEmail || this.props.fieldsTouched) &&
													errors.checkedEmail && (
														<div className='error-msg'>
															<FiAlertCircle size={13} />
															<small className='credit-card-error'>
																{errors.checkedEmail}
															</small>
														</div>
													)}
											</FormField>
										): ''}

									{/*<pre>{JSON.stringify(this.state.inputData)}</pre>
									<pre>{JSON.stringify(this.initialValues)}</pre>
									<pre>{JSON.stringify(values)}</pre>*/}
								</Form>
							);
						}}
					</Formik>
				</BoxSize>
			</>
		)); 
	}
}

export default FormBeneficiario;

export function CustomInputMask(props) {
	const [field] = useField({
		name: props.name,
		type: 'text',
		id: props.id,
		mask: props.mask,
		maskChar: props.maskChar
	});
	return (
		<InputMask
			{...props}
			{...field}
			className='form-control'
			onChange={props.onChange}
			onBlur={props.onBlur}
			value={props.value}
		/>
	);
}
